import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';

export const life: LifeFeatureConfig = {
    overview: {
        useCountrySpecificApi: true,
        useBeneficiaryApi: false,
        highlight: {
            showNextPaymentDate: false,
        },
        details: {
            showContractedInsurances: false,
            showVariant: true,
            showPackage: false,
            showContractNumber: false,
            fallbackAssistancePhonesKey: 'CZ',
            fallbackAssistanceEmailsKey: 'CZ_LIFE',
        },
        showCoveredRisks: false,
        showUncoveredRisks: false,
        showInsuredPersons: false,
        showBeneficiaries: false,
    },
    history: {
        visible: true,
    },
    risks: {
        visible: true,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
